<div class="row">
  <div class="col-md-12">
    <span i18n class="mb-3" [className]="required ? 'mandatory' : ''">
      <app-pass-restricted-checkbox-texts [textKey]="title"/>
    </span>
    <div [formGroup]="group" class="form-check ms-4">
      <app-checkbox
        *ngFor="let name of controlNames"
        [controlName]="name"
        [control]="$any(group.get(name))"
        (clickHandler)="onCheckboxClick($event)"
      >
        <app-pass-restricted-checkbox-texts class="app-label" [textKey]="labelFor(name)" />
      </app-checkbox>
    </div>
  </div>
</div>
